import type { ProjectData } from '../../types';
import Component from './content.mdx';

const data: ProjectData = {
    slug: 'caribbeanrealestatemls',
    title: 'Caribbean Real Estate MLS',
    description: 'Caribbean Real Estate MLS is a real estate platform that connects buyers and sellers in the Caribbean. The platform allows users to search for properties, view property details, and contact sellers.',
    fileName: 'content.mdx',
    markdown: Component,
    info: {
        stack: [
            'React',
            'TypeScript',
            'Material-UI',
            'Node.js',
            'Next.js',
            'Docker',
            'PostgreSQL',
        ],
        url: 'https://caribbeanrealestatemls.com',
    },
};

export default data;
